import { render, staticRenderFns } from "./LocationSleepingClientsOnMapDashboard.vue?vue&type=template&id=678e8e2b&"
import script from "./LocationSleepingClientsOnMapDashboard.vue?vue&type=script&lang=js&"
export * from "./LocationSleepingClientsOnMapDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports